<template>
  <div class="packagemanagement">
    <!-- 工具条 -->
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline toolbar"
      style="padding-bottom: 0px"
      @submit.native.prevent
    >
      <el-form-item label="套餐名称">
        <el-input
          v-model.trim="formInline.name"
          placeholder="请输入套餐名称"
          clearable
          @keyup.enter.native.prevent="enterSearchMember"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" plain @click="onSubmit"
          >查询</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="warning"
          icon="el-icon-plus"
          plain
          @click="handleAddPackage"
          >新增套餐</el-button
        >
      </el-form-item>
    </el-form>
    <!--表格内容栏-->
    <div>
      <el-table
        :data="tableData"
        element-loading-text="记载中..."
        :loading="tableLoading"
        :header-cell-style="{
          'text-align': 'center',
          'font-size': '16px',
          'font-weight': '600',
          color: '#2d2d2d',
          'background-color': '#d4f5fa',
        }"
        :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
        :row-style="tableRowStyle"
        style="width: 100%"
      >
        <el-table-column
          prop="name"
          label="套餐名称"
          min-width="150"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="createdTime"
          label="创建时间"
          min-width="180"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="actualPrice"
          label="套餐金额"
          min-width="200"
          align="center"
        ></el-table-column>
        <el-table-column label="启用状态" min-width="200" align="center">
          <template slot-scope="scope">
            <span
              v-if="scope.row.status == 0"
              @click="handleClickZero(scope.$index, scope.row)"
            >
              <el-switch
                v-model="scope.row.flag"
                active-color="#09a3c1"
                inactive-color="#ccc"
                active-text="启用"
                inactive-text="初始状态"
              >
              </el-switch>
            </span>
            <span
              v-if="scope.row.status == 1"
              @click="handleClickOne(scope.$index, scope.row)"
            >
              <el-switch
                v-model="scope.row.flag"
                active-color="#09a3c1"
                inactive-color="#ccc"
                active-text="启用"
                inactive-text="禁用"
              >
              </el-switch>
            </span>
            <span
              v-if="scope.row.status == 2"
              @click="handleClickTwo(scope.$index, scope.row)"
            >
              <el-switch
                v-model="scope.row.flag"
                active-color="#09a3c1"
                inactive-color="#ccc"
                active-text="启用"
                inactive-text="禁用"
              >
              </el-switch>
            </span>
          </template>
        </el-table-column>
        <el-table-column label="退费公式" min-width="200" align="center">
          <template slot-scope="scope">
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="handleRefundFormula(scope.$index, scope.row)"
              >查看</el-button
            >
            <!-- <img class="imgsize2" src="@/assets/beadhouse/tuiFeiGongShi_icon.png" alt="" @click="handleRefundFormula(scope.$index,scope.row)"> -->
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="280" align="center">
          <template slot-scope="scope">
            <!-- <img class="imgMarginLeft" src="@/assets/beadhouse/chakan(1).png" alt="" @click="handleLook(scope.$index,scope.row)">
            <img class="imgMarginLeft" src="@/assets/beadhouse/bianji_icon.png" alt="" @click="handleEdit(scope.$index,scope.row)">
            <img class="imgMarginLeft" src="@/assets/beadhouse/shanchu_icon.png" alt="" @click="handledelete(scope.$index,scope.row)"> -->
            <el-button
              style="margin-right: 5px"
              type="success"
              size="mini"
              plain
              @click="handleLook(scope.$index, scope.row)"
              >查看</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="primary"
              size="mini"
              plain
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              style="margin-right: 5px"
              type="danger"
              size="mini"
              plain
              @click="handledelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        layout="total, prev, pager, next"
        :total="totalDataNumber"
        :page-size="pageSize"
        align="center"
        class="fenye"
      >
      </el-pagination>
    </div>
    <!--新增和 编辑 套餐界面-->
    <el-dialog
      class="packagedialog"
      :title="operation ? '添加套餐' : '修改套餐'"
      :visible.sync="dialogFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="packageForm"
        label-width="100px"
        :rules="packageFormRules"
        ref="packageForm"
      >
        <el-form-item label="套餐名称:" prop="name">
          <el-input
            v-model.trim="packageForm.name"
            :maxlength="10"
            auto-complete="off"
            style="width: 217px"
          ></el-input>
        </el-form-item>
        <el-row class="tree-row">
          <!-- node-key="id" by guo 2019-11-18-19:05修改 这里将id换成idIns作为识别键 -->
          <el-tree
            class="packagemanagement-tree"
            :data="data"
            show-checkbox
            node-key="idIns"
            highlight-current
            ref="tree"
            :default-checked-keys="defaultCheckedKeys"
            :default-expand-all="false"
            :expand-on-click-node="false"
            @node-click="handleNodeClick"
            @check="checkClick"
            @check-change="checkChange"
            :props="defaultProps"
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span class="labelOne">{{ node.label.labelOne }}</span>
              <span class="custom-tree-node-1">{{ node.label.labelTwo }}</span>
              <span class="custom-tree-node-1">{{
                node.label.labelThree
              }}</span>
              <span
                v-show="node.label.show == true"
                class="custom-tree-node-show"
              >
                <el-input
                  style="width: 60px"
                  type="number"
                  size="mini"
                  v-model="node.label.times"
                  min="0"
                  max="99"
                  @change="changeValue"
                ></el-input>
              </span>
            </span>
          </el-tree>
        </el-row>
        <el-row class="row-border">
          <el-row class="row-border-child">
            <el-col :span="10" :offset="2"
              ><span>套餐原价:</span
              ><span>{{ originalPrice | keepTwoNum }}</span></el-col
            >
            <el-col :span="12">
              <span>实际价格:</span>
              <!-- <span><el-input v-model="actualPrice" :disabled="true" auto-complete="off" style="width:60%;"></el-input></span> -->
              <span>{{ actualPrice | keepTwoNum }}</span>
            </el-col>
          </el-row>
          <el-row class="row-border-child">
            <!-- by guo 2019-09-10 10:00 修改   改成可以输入减免金额的 -->
            <!-- <el-col :span=10 :offset=2><span>减免金额:</span><span>{{reduceFee | keepTwoNum}}</span></el-col> -->
            <el-col :span="10" :offset="2">
              <span>减免金额:</span>
              <span
                ><el-input
                  v-model.trim="reduceFee"
                  :maxlength="10"
                  auto-complete="off"
                  style="width: 60%"
                  @change="changeReduceFee"
                ></el-input
              ></span>
            </el-col>
            <el-col :span="12">
              <span>打折额度:</span>
              <span>
                <el-autocomplete
                  style="width: 60%"
                  popper-class="my-autocomplete"
                  v-model="discount"
                  :fetch-suggestions="querySearch"
                  placeholder="请输入打折额度"
                  @select="handleSelect"
                  @blur="blurDiscount"
                >
                  <template slot-scope="{ item }">
                    <!-- <div class="name">{{ item.value }}</div> -->
                    <span class="addr">{{ item.key }}</span>
                  </template>
                  <span class="zhe" slot="suffix">折</span>
                </el-autocomplete>
              </span>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-top: 10px"
      >
        <el-button
          @click.native="dialogFormVisible = false"
          style="display: inline"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="packageFormLoading"
          style="display: inline"
          >确定</el-button
        >
      </div>
    </el-dialog>
    <!-- 退费公式的dialog模态框 -->
    <el-dialog
      title="退费公式"
      :visible.sync="dialogFormVisibleRefundFormula"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form
        :model="refundFormulaForm"
        label-width="100px"
        :rules="refundFormulaFormRules"
        ref="refundFormulaForm"
      >
        <el-form-item>
          <el-row class="rowmoney">
            <el-col :span="24"
              ><span>套餐总金额:</span
              ><span>{{ packageTotalFee | keepTwoNum }}</span></el-col
            >
          </el-row>
        </el-form-item>
        <el-form-item
          :label="item.name + item.chargeStandard"
          v-for="(item, index) in formList"
          :key="index"
        >
          <el-row class="rowlineheight">
            <el-col :span="10"
              ><el-input
                v-model="item.itemName"
                :disabled="true"
                :maxlength="10"
                auto-complete="off"
                class="width100"
              ></el-input
            ></el-col>
            <el-col :span="1" align="center">×</el-col>
            <el-col :span="10"
              ><el-input
                v-model="item.returnStandard"
                :maxlength="10"
                auto-complete="off"
                class="width100"
              ></el-input
            ></el-col>
          </el-row>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
        style="text-align: center; margin-top: 10px"
      >
        <el-button
          @click.native="dialogFormVisibleRefundFormula = false"
          style="display: inline"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click.native="refundFormulaFormSubmit"
          :loading="refundFormulaFormLoading"
          style="display: inline"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import bus from "../../vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name: "PackageManagement",
  components: {},
  data() {
    return {
      /* 工具条 form表单数据 */
      formInline: {
        name: "",
      },

      /* 表格的模拟数据 */
      tableData: [],
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      /* 新增和编辑套餐的dialog模态框的配置 */
      dialogFormVisible: false, //dialog默认关闭
      packageFormLoading: false, //确定按钮加载 默认为false
      packageForm: {
        name: "",
      }, //数据源
      packageFormRules: {
        name: [
          { required: true, message: "不能为空", trigger: "blur" },
          { min: 1, max: 10, message: "长度在 1到 10 个的字符" },
        ],
      },
      operation: true, //默认是添加餐套  false为修改
      //套餐树
      data: [],
      //套餐树默认显示的
      defaultProps: {
        children: "expenseItemList",
        label: "label",
      },
      checkedList: [], //套餐树被选中的数组
      defaultCheckedKeys: [], //修改时默认被选中数组
      originalPrice: 0, //原价
      actualPrice: 0, //实际价格
      reduceFee: "", //减免金额
      discount: "", //打折的input框数据
      discountOptions: [], //折扣的数据

      /* 退费公式的dialog模态框配置 */
      dialogFormVisibleRefundFormula: false, //默认关闭
      refundFormulaForm: {}, //数据源
      formList: [], //退费公式form表单的数组
      refundFormulaFormRules: {}, //正则匹配规则
      refundFormulaFormLoading: false, //确定按钮加载loading
      packageTotalFee: 0, //套餐总金额
      realPrice: 0, //实际价格  用于退费校验 by xiang
    };
  },
  filters: {
    keepTwoNum(value) {
      value = Number(value);
      return value.toFixed(2);
    },
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    /* 
      查询按钮查询
    */
    onSubmit() {
      console.log("aaaaaaaa");
      if (this.formInline.name == "") {
        this.querAllPackage(this.formInline.name, (this.pageNum = 1));
      } else {
        this.querAllPackage(
          this.formInline.name,
          (this.pageNum = 1),
          (this.pageSize = 10)
        );
      }
    },

    /* 
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.name != null) {
        if (this.formInline.name == "") {
          this.querAllPackage(this.formInline.name, (this.pageNum = 1));
        } else {
          this.querAllPackage(
            this.formInline.name,
            (this.pageNum = 1),
            (this.pageSize = 10)
          );
        }
      }
    },

    /* 
      新增菜单弹出dialog模态框
    */
    handleAddPackage() {
      this.$nextTick(() => {
        if (this.$refs.packageForm != undefined) {
          this.$refs.packageForm.resetFields();
        }
      });
      this.operation = true;
      this.dialogFormVisible = true;
      this.packageForm = {
        name: "",
      };
      this.defaultCheckedKeys = []; //初始化tree checkbox回显的数据
      (this.originalPrice = 0), //初始化原价
        (this.actualPrice = 0), //初始化实际价格
        (this.reduceFee = ""), //初始化减免金额
        (this.discount = ""), //初始化打折的input框数据
        this.queryAllCategory(); //打开模态框数据初始化
    },

    /* 
      减免金额的change事件  by guo 2019-09-10 10:00  添加
    */
    changeReduceFee(val) {
      console.log(val);
      var reg = /(^[0-9](\d+)?(\.\d{1,2})?$)|(^\d\.\d{1,2}$)/g; //大于等于0的数，最多可以有两位小数正则表达式
      if (reg.test(this.reduceFee)) {
        if (this.reduceFee <= this.originalPrice) {
          this.actualPrice = parseFloat(
            this.originalPrice - Number(this.reduceFee)
          ).toFixed(2);
          this.discount = parseFloat(
            (this.actualPrice / this.originalPrice) * 10
          ).toFixed(2);
          console.log(this.actualPrice, "-----");
        } else {
          this.$message({ message: "减免金额不能大于套餐原价", type: "error" });
          this.reduceFee = "";
          this.discount = "";
        }
      } else {
        this.$message({
          message: "请输入不小于0并且最多只能有两位小数的金额",
          type: "error",
        });
      }
    },

    /* 
      打折的change事件
    */
    blurDiscount(e) {
      console.log(e);
      this.discount = e.target.value
        ? parseFloat(e.target.value).toFixed(2)
        : "";
      //如果输入非Number清空  by xiang
      if (isNaN(this.discount)) {
        this.discount = 0;
      }
      //如果输入大于10 变为10 by xiang
      if (this.discount > 10) {
        this.discount = 10.0;
      }
      console.log(this.discount);
      if (this.discount > 0) {
        //打折后  by guo 2020-7-3-15:58将this.discount>=0修改为this.discount>0
        this.actualPrice = parseFloat(
          this.originalPrice * (this.discount / 10)
        ).toFixed(2); //实际价格
        this.reduceFee = parseFloat(
          this.originalPrice - this.actualPrice
        ).toFixed(2); //减免金额
      } else {
        //未打折
        this.actualPrice = this.originalPrice;
        this.reduceFee = "";
        this.discount = ""; //by guo 2020-7-3-15:59添加
      }
      console.log(this.actualPrice, "this.actualPrice");
      console.log(this.reduceFee, "this.reduceFee");
    },

    /* 
      打折的下拉事件
    */
    handleSelect(item) {
      console.log(item);
      this.discount = item.value;
      console.log(this.discount, "----");
      if (this.discount > 0) {
        //打折后
        this.actualPrice = parseFloat(
          this.originalPrice * (this.discount / 10)
        ).toFixed(2); //实际价格
        this.reduceFee = parseFloat(
          this.originalPrice - this.actualPrice
        ).toFixed(2); //减免金额
      } else {
        //未打折
        this.actualPrice = this.originalPrice;
        this.reduceFee = "";
      }
      console.log(this.actualPrice, "this.actualPrice");
      console.log(this.reduceFee, "this.reduceFee");
    },

    /* 
      折扣的搜索
    */
    querySearch(queryString, cb) {
      var discountOptions = this.discountOptions;
      var results = queryString
        ? discountOptions.filter(this.createFilter(queryString))
        : discountOptions;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },

    /*  
      折扣值的过滤
    */
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },

    /* 
      打折加载的数据
    */
    loadAll() {
      return [
        { value: "1.00", key: "1折" },
        { value: "2.00", key: "2折" },
        { value: "3.00", key: "3折" },
        { value: "4.00", key: "4折" },
        { value: "5.00", key: "5折" },
        { value: "6.00", key: "6折" },
        { value: "7.00", key: "7折" },
        { value: "8.00", key: "8折" },
        { value: "9.00", key: "9折" },
      ];
    },

    /* 
      新增套餐提交数据
    */
    addSubmit() {
      console.log("提交");
      this.$refs.packageForm.validate((valid) => {
        if (valid) {
          let setMealItemList = this.dealSetMealItemList(this.data); //调方法  获取setMealItemList数组
          console.log(setMealItemList, "setMealItemList");
          //判断数组中是否有值  有就提交数据  没有就提示请添加套餐项目
          if (setMealItemList.length > 0) {
            let params = {};
            params = Object.assign({}, this.packageForm); //获取name
            params.originalPrice = this.originalPrice; //原价
            params.actualPrice = this.actualPrice; //实际价格
            params.subPrice = this.reduceFee; //减免金额
            params.discount = this.discount * 100; //打折
            params.remark = "";
            params.setMealItemList = setMealItemList;
            console.log(params);
            this.packageFormLoading = true;
            this.$postJson(
              this.operation ? "fmc/setMeal/add" : "fmc/setMeal/edit",
              params
            ).then((res) => {
              console.log(res);
              if (res.code == 200) {
                this.$message({ message: res.message, type: "success" });
              } else {
                this.$message({ message: res.message, type: "error" });
              }
              this.packageFormLoading = false;
              this.dialogFormVisible = false;
              this.querAllPackage(); //刷新数据
            });
          } else {
            this.$message({ message: "请添加套餐项目", type: "error" });
          }
        }
      });
    },

    /* 
      处理提交的Json数组
    */
    dealSetMealItemList(info) {
      console.log(info);
      let setMealItemList = [];
      info.forEach((item) => {
        console.log(item);
        item.expenseItemList.forEach((temp) => {
          console.log(temp, "------------");
          //筛选出选中状态  和 time 次数大于1 的服务项目
          if (temp.check == true && temp.label.times > 0) {
            let setMealItemObj = {};
            setMealItemObj.expenseItemId = temp.id;
            setMealItemObj.times = temp.label.times;
            setMealItemObj.remark = temp.content;
            setMealItemList.push(setMealItemObj);
          }
        });
      });
      console.log(setMealItemList, "!!!!!!!!!!!!!");
      return setMealItemList;
    },

    /* 
      点击tree菜单
    */
    handleNodeClick(data, node, vuecomponent) {
      console.log(data, node, vuecomponent);
      console.log(this.data);
      this.preOrder(this.data, this.checkedList);
      this.originalPrice = 0;
      //两次循环遍历节点找出 check属性为true的 为选中状态  参与计算    为false就去除掉  不参与计算
      this.data.forEach((item) => {
        item.expenseItemList.forEach((temp) => {
          if (temp.check == true) {
            this.originalPrice += temp.label.labelThree * temp.label.times; //原价
          }
        });
      });
      console.log(this.originalPrice, "原价");
      if (this.discount > 0) {
        //打折后
        this.actualPrice = this.originalPrice * (this.discount / 10); //实际价格
        this.reduceFee = parseFloat(
          this.originalPrice - this.actualPrice
        ).toFixed(2); //减免金额
      } else {
        //未打折
        this.actualPrice = this.originalPrice;
        this.reduceFee = "";
      }
      console.log(this.actualPrice, "this.actualPrice");
      console.log(this.reduceFee, "this.reduceFee");
    },

    /* 
      节点checkbox选中被改变的事件    by  guo 2019 8-18  16:50  这个事件有bug 先注释掉
    */
    checkChange(data, checked, indeterminate) {
      console.log(data, checked, indeterminate);
      // let res = this.$refs.tree.getCheckedNodes();
      // console.log(res)
      // this.checkedList=[];
      // res.forEach((item,index) => {
      //   //去掉父节点  父节点的 item.label.show为false
      //   if(item.label.show==true){
      //     this.checkedList.push(item.id)
      //   }
      // })
      // console.log(this.checkedList);
      // console.log(this.data);
      // this.preOrder(this.data,this.checkedList);
      // this.originalPrice=0;
      // this.actualPrice=0;
      // this.reduceFee=0;
      // this.discount='';
      // //两次循环遍历节点找出 check属性为true的 为选中状态  参与计算    为false就去除掉  不参与计算
      // this.data.forEach(item=>{
      //   item.expenseItemList.forEach(temp=>{
      //     if(temp.check==true){
      //       this.originalPrice+=(temp.label.labelThree)*(temp.label.times);
      //       this.actualPrice+=(temp.label.labelThree)*(temp.label.times);
      //       this.reduceFee=this.originalPrice-this.actualPrice;
      //     }
      //   })
      // })
      // console.log(this.originalPrice,"原价");
    },

    /* 
      input值变化的时候调用时间 by xiang 
    */
    changeValue() {
      this.checkClick();
    },
    /* 
      节点checkbox点击事件    by  guo 2019 8-18  16:50  先用这个事件  
    */
    checkClick(checkedNodes, checkedKeys) {
      console.log(checkedNodes, checkedKeys);
      let res = this.$refs.tree.getCheckedNodes();
      console.log(res);
      this.checkedList = [];
      res.forEach((item, index) => {
        //去掉父节点  父节点的 item.label.show为false
        if (item.label.show == true) {
          this.checkedList.push(item.id);
        }
      });
      console.log(this.checkedList);
      console.log(this.data);
      this.preOrder(this.data, this.checkedList);
      this.originalPrice = 0;
      this.actualPrice = 0;
      // this.reduceFee=0;//by guo 2019-09-10 10:50 修改
      // this.discount='';//by guo 2019-09-10 10:50 修改
      //两次循环遍历节点找出 check属性为true的 为选中状态  参与计算    为false就去除掉  不参与计算
      this.data.forEach((item) => {
        item.expenseItemList.forEach((temp) => {
          if (temp.check == true) {
            this.originalPrice += temp.label.labelThree * temp.label.times;
            this.actualPrice += temp.label.labelThree * temp.label.times;
            this.reduceFee = this.originalPrice - this.actualPrice;
          }
        });
      });
      console.log(this.originalPrice, "原价");
    },

    //循环tree节点  判断节点选中的状态
    preOrder(data, checkedList) {
      console.log(data, checkedList);
      var childs = data;
      //两次循环遍历比较tree数据源的id 和checkList 被选中的id 是否相同
      for (var i = 0; i < childs.length; i++) {
        console.log(childs[i], "-----------***********");
        for (var k = 0; k < childs[i].expenseItemList.length; k++) {
          //判断checkList是否存在  存在就循环遍历比较
          if (checkedList.length > 0) {
            console.log(childs[i].expenseItemList[k]);
            if (this.$refs.tree) {
              console.log(checkedList.indexOf(childs[i].expenseItemList[k].id));
              //判断checkedList数组中是否含有childs[i].expenseItemList[k].id这个值  !=-1 就是含有
              if (checkedList.indexOf(childs[i].expenseItemList[k].id) != -1) {
                childs[i].expenseItemList[k].check = true; //含有 就check为true
              } else {
                childs[i].expenseItemList[k].check = false; //不含有  就check为false
              }
            }
          } else {
            //直接对应的数据置为false
            childs[i].expenseItemList[k].check = false;
          }
        }
      }
      console.log(data, "data");
    },

    /* 
      套餐管理启用和禁用  当status==0时
    */
    handleClickZero(index, row) {
      console.log(index, row);
      let setMealId = row.id;
      this.changeStatusData(setMealId); //获取套餐启用/禁用的数据
    },

    /* 
      套餐管理启用和禁用  当status==1时
    */
    handleClickOne(index, row) {
      console.log(index, row);
      let setMealId = row.id;
      this.changeStatusData(setMealId); //获取套餐启用/禁用的数据
    },

    /* 
      套餐管理启用和禁用  当status==2时
    */
    handleClickTwo(index, row) {
      console.log(index, row);
      let setMealId = row.id;
      this.changeStatusData(setMealId); //获取套餐启用/禁用的数据
    },

    /* 
       套餐管理-启用/禁用获取数据
    */
    changeStatusData(setMealId) {
      this.$postJson("fmc/setMeal/changeStatus/" + setMealId).then((res) => {
        console.log(res);
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
        this.querAllPackage(); //刷新数据
      });
    },

    /* 
      打开退费公式模态框
    */
    handleRefundFormula(index, row) {
      this.dialogFormVisibleRefundFormula = true;
      let setMealId = row.id;
      this.queryPackageDetail(setMealId);
      this.packageId = row.id;
      this.realPrice = row.actualPrice;
    },

    /* 
      退费公式提交数据
    */
    refundFormulaFormSubmit() {
      //添加退费公式的校验 by  xiang
      let allRefund = 0;
      console.log(this.formList);
      let HaveTrue = [];
      for (var i = 0; i < this.formList.length; i++) {
        allRefund += this.formList[i].returnStandard * this.formList[i].times;
        if (
          this.formList[i].chargeStandard < this.formList[i].returnStandard ||
          this.formList[i].returnStandard < 0
        ) {
          HaveTrue.push("fasle");
        }
      }
      let isTrue = HaveTrue.every((item) => {
        return item == "false";
      });
      console.log(allRefund);
      console.log(this.realPrice);
      if (allRefund > this.realPrice || !isTrue || isNaN(allRefund)) {
        this.$message({
          message: "退费公式金额填写有误，请重新输入",
          type: "error",
        });
      } else {
        this.refundSubmit();
      }
    },

    /* 
      退费公式的提交
    */
    refundSubmit() {
      let setMealItemList = this.dealRefundFormulaData(this.formList); //获取提交的数组数据
      let params = {};
      params.id = this.packageId; //套餐Id
      params.setMealItemList = setMealItemList;
      console.log(params);
      this.$postJson("fmc/setMeal/setReturnStandard", params).then((res) => {
        if (res.code == 200) {
          this.$message({ message: res.message, type: "success" });
        } else {
          this.$message({ message: res.message, type: "error" });
        }
        this.dialogFormVisibleRefundFormula = false;
      });
    },

    /* 
      退费公式处理提交的数组
    */
    dealRefundFormulaData(info) {
      let setMealItemList = [];
      info.forEach((item) => {
        let setMealItemObj = {};
        setMealItemObj.id = item.id;
        setMealItemObj.returnStandard = item.returnStandard;
        setMealItemList.push(setMealItemObj);
      });
      console.log(setMealItemList);
      return setMealItemList;
    },

    /* 
      查看详情
    */
    handleLook(index, row) {
      console.log(index, row);
      console.log("跳转到套餐详情页面");
      // bus.$emit('package',{params:{setMealId:row.id}});//传参给子页面
      // bus.$emit('homePage',{type:'jump',path:'/PackageDetail',title:'套餐详情'});
      //by guo 2019-8-28 11：05 修改
    },

    /* 
      编辑
    */
    handleEdit(index, row) {
      console.log(index, row);
      console.log("修改-----------");
      this.operation = false;
      this.dialogFormVisible = true;
      this.packageForm.name = row.name;
      this.packageForm.id = row.id;
      this.originalPrice = row.originalPrice; //原价
      this.actualPrice = row.actualPrice; //实际价格
      this.reduceFee = row.subPrice; //减免金额
      this.discount = (row.discount / 100).toFixed(2); //折扣
      this.queryAllCategory(); //先请求queryAllCategory类别的数据，刷新初始化this.data数据源
      setTimeout(() => {
        this.queryPackageDetail(row.id);
      }, 500);
    },

    /* 
      删除套餐
    */
    handledelete(index, row) {
      console.log(index, row);
      this.$confirm("确定要删除该套餐吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
        closeOnClickModal: false,
      })
        .then(() => {
          let setMealId = row.id;
          this.$postJson("fmc/setMeal/deleteById/" + setMealId).then((res) => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
            } else {
              this.$message({ message: res.message, type: "error" });
            }
            this.querAllPackage(); //刷新数据
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },

    /* 
      套餐管理-分页查询
    */
    querAllPackage() {
      let params = {};
      params.name = this.formInline.name;
      params.pageNum = this.pageNum;
      params.pageSize = this.pageSize;
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      this.$postJson("fmc/setMeal/queryListWithPage", params).then((res) => {
        console.log(res);
        if (res.code == 200) {
          if (res.result.list.length != 0) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            //循环遍历处理数据 给不同的启用状态添加一个flag属性用于回显数据  0 初始状态 flag==false     1  启用状态  flag==true  2禁用状态  flag==false
            res.result.list.forEach((item) => {
              let object = {};
              object = Object.assign({}, item);
              switch (item.status) {
                case 0:
                  object.flag = false;
                  break;
                case 1:
                  object.flag = true;
                  break;
                case 2:
                  object.flag = false;
              }
              this.tableData.push(object);
            });
          } else {
            this.tableData = [];
            this.totalDataNumber = 0;
          }
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 1000);
      });
    },

    /* 
      套餐详情
    */
    queryPackageDetail(setMealId) {
      this.defaultCheckedKeys = []; //请求之前先把数据清空,防止累加
      this.formList = []; //请求之前先把数据清空,防止累加
      this.$postJson("fmc/setMeal/getById/" + setMealId).then((res) => {
        console.log(res, "_---------------");
        console.log(this.data);
        if (res.code == 200) {
          this.packageTotalFee = res.result.originalPrice;
          this.data.forEach((item) => {
            item.expenseItemList.forEach((temp) => {
              res.result.setMealItemVoList.forEach((set) => {
                //通过判断 item.id==set.expenseTypeId  和 temp.id==set.expenseItemId 来获取数据
                if (
                  item.id == set.expenseTypeId &&
                  temp.id == set.expenseItemId
                ) {
                  console.log("fwerghireijgireijherjihijreijhreijhijrehijeij");
                  temp.check = true;
                  temp.label.times = set.times;
                  // this.defaultCheckedKeys.push(set.expenseItemId);//修改的dialog回显的checkbox数据
                  this.defaultCheckedKeys.push(temp.idIns); //修改的dialog回显的checkbox数据  by guo 2019-11-18-19:01修改  使用拼接的idIns作为唯一键识别  因为使用expenseItemId  父子级的节点可能存在相同的id和expenseItemId 导致回显的数据错乱
                }
                let formObj = {};
                formObj.id = set.id;
                // formObj.name=set.name;
                formObj.name = set.expenseTypeName; //by guo 2019-09-19 18:36  后端变更了字段
                formObj.itemName = set.itemName;
                formObj.returnStandard = set.returnStandard;
                //添加单价和次数用于退费公式的限制 by xiang
                formObj.times = set.times;
                formObj.chargeStandard = set.chargeStandard;
                this.formList.push(formObj);
              });
            });
          });
        }
        console.log(this.data, "修改后的this.data");

        console.log(this.defaultCheckedKeys);
        if (this.$refs.tree) {
          this.$refs.tree.setCheckedKeys(this.defaultCheckedKeys);
        }
        //利用reduce方法遍历数组,reduce第一个参数是遍历需要执行的函数，第二个参数是item的初始值   去重
        var formListObj = {};
        this.formList = this.formList.reduce(function (item, next) {
          formListObj[next.id]
            ? ""
            : (formListObj[next.id] = true && item.push(next));
          return item;
        }, []);
        console.log(this.formList, "this.formList");
      });
    },

    /* 
      查询费用类别及项目
    */
    queryAllCategory() {
      this.data = []; //请求之前先将数据置空，防止累加
      this.$postJson("fmc/feeItem/queryAllTypes").then((res) => {
        console.log(res);
        if (res.code == 200) {
          res.result.forEach((item) => {
            console.log(item);
            if (item.expenseItemList != null) {
              var expenseItemList = [];
              item.expenseItemList.forEach((temp) => {
                let dataObj = {
                  label: {
                    labelOne: "",
                    labelTwo: "",
                    labelThree: "",
                    show: false,
                    times: 0,
                  },
                };
                let expenseItemObj = {
                  label: {
                    labelOne: "",
                    labelTwo: "",
                    labelThree: "",
                    show: true,
                    times: 0,
                    expenseItemList: [],
                  },
                };
                dataObj.label.labelOne = item.name;
                dataObj.label.labelTwo = "";
                dataObj.label.labelThree = "";
                dataObj.id = item.id;
                dataObj.check = false;
                expenseItemObj.id = temp.id;
                expenseItemObj.check = false;
                expenseItemObj.expenseTypeId = temp.expenseTypeId;
                expenseItemObj.isFixedPrice = temp.isFixedPrice;
                expenseItemObj.content = temp.content;
                expenseItemObj.label.labelOne = temp.itemName;
                expenseItemObj.idIns = temp.id + "-" + temp.expenseTypeId; //by guo 2019-11-18-18:49 添加  idIns为tree数回显的id唯一键
                switch (temp.costType) {
                  case 1:
                    temp.costType = "元/次";
                    break;
                  case 2:
                    temp.costType = "元/天";
                    break;
                  case 3:
                    temp.costType = "元/月";
                    break;
                  case 4:
                    temp.costType = "元/年";
                    break;
                  case 5:
                    temp.costType = "元/一次性";
                    break;
                }
                expenseItemObj.label.labelTwo = temp.costType;
                expenseItemObj.label.labelThree = temp.chargeStandard;
                console.log(expenseItemObj, "_______________");
                expenseItemList.push(expenseItemObj);
                dataObj.expenseItemList = expenseItemList;
                console.log(dataObj.expenseItemList, "***************");
                console.log(dataObj, "$$$$");
                this.data.push(dataObj);
              });
            }
          });
        }
        console.log(this.data, "this.data--------------------");
        //利用reduce方法遍历数组,reduce第一个参数是遍历需要执行的函数，第二个参数是item的初始值  去重
        var obj = {};
        this.data = this.data.reduce(function (item, next) {
          obj[next.id] ? "" : (obj[next.id] = true && item.push(next));
          return item;
        }, []);
        console.log(this.data, "+++++++++++");
      });
    },

    /* 
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      //改变每页显示的条数
      this.PageSize = val;
      this.querAllPackage(); //刷新套餐列表的数据
    },

    /* 
      当前页变化
    */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.pageNum = val;
      this.querAllPackage(); //刷新套餐列表的数据
    },

    /* 
      表头的颜色
    */
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color:#bee1f4;color:#6f7075;font-weight: 700;height:50px;";
      }
    },
  },
  created() {},
  mounted() {
    this.queryAllCategory();
    this.querAllPackage();
    this.discountOptions = this.loadAll();
  },
};
</script>
<style lang="scss" scoped>
.packagemanagement {
  .imgMarginLeft {
    margin-left: 10px;
    cursor: pointer;
    width: 22px;
    height: 22px;
  }
  .imgsize1 {
    width: 30px;
    height: 18px;
    cursor: pointer;
  }
  .imgsize2 {
    width: 30px;
    height: 24px;
    cursor: pointer;
  }
  .labelOne {
    display: inline-block;
    width: 150px;
    margin-left: 10px;
    height: 20px;
    line-height: 20px;
    text-align: left;
  }
  .custom-tree-node-1 {
    display: inline-block;
    margin-left: 20px;
    width: 100px;
    text-align: left;
  }
  .custom-tree-node-show {
    display: inline-block;
    width: 100px;
    text-align: left;
    margin-left: 50px;
  }
  .row-border {
    width: 100%;
    height: 100px;
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .row-border-child {
      height: 50px;
      line-height: 50px;
    }
  }
  .tree-row {
    width: 95%;
    margin: 0 auto;
    max-height: 300px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .class100 {
    width: 100%;
  }
  .rowlineheight {
    height: 40px;
    line-height: 40px;
  }
  .rowmoney {
    width: 40%;
    margin: 0 auto;
  }
  .width210 {
    width: 210px;
  }
  .my-autocomplete {
    li {
      line-height: normal;
      padding: 7px;

      .name {
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .addr {
        font-size: 12px;
        color: #b4b4b4;
      }

      .highlighted .addr {
        color: #ddd;
      }
    }
    .zhe {
      font-size: 16px !important;
      line-height: 40px !important;
      margin-right: 10px !important;
      color: black !important;
    }
  }
}
::v-deep .el-tree-node__content {
  height: 40px !important;
}
::v-deep
  .packagemanagement-tree
  .el-tree-node.is-current
  > .el-tree-node__content {
  background: #fff !important;
  color: #606266 !important;
  border-radius: 5px !important;
}
::v-deep .packagemanagement-tree .el-checkbox {
  height: 30px;
  line-height: 28px;
}
.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}
 //  ::v-deep深度作用选择符
  ::v-deep .el-dialog__header {
    text-align: left;
    background: rgb(238, 231, 231);
    border-bottom: 2px solid rgb(211, 207, 207);
  }
</style>